import React, { useRef, useState } from 'react';
import { useSortable } from '@dnd-kit/react/sortable';
import {NavLink} from "react-router-dom";
import {vesselType} from "../../../../util/varibles/constants";
import styles from './style.module.scss';
import {IVessel} from "../../../../util/varibles/interface";
import {IVesselHeight} from "./index";

interface IProps {
    index: number
    data: IVessel & { isPermission: boolean }
    vesselHeight: IVesselHeight
}

const Vessel: React.FC<IProps> = ({index, data, vesselHeight}) => {
    const [element, setElement] = useState<Element | null>(null);
    const handleRef = useRef<HTMLDivElement | null>(null);
    const {isDragging} = useSortable({
        id: data.id,
        index,
        element,
        handle: handleRef,
    });
    const {name, type, id, isPermission} = data;
    const {name: nameVesselType = ''} = vesselType[type] || {};
    const style = {
        height: `calc(var(--${id}-height) + var(--more-height, 0px))`
    }

    return <div
        ref={setElement}
        className={styles.vessel}
        style={style}
        data-is-permission={isPermission}
        data-dragging={isDragging || undefined}
    >
        <div className={styles.spacer} style={{height: `calc(var(--${id}-content-top) + .5px)`}}/>
        <div ref={handleRef} className={`${styles.vesselContent} ${styles.vesselDragHandle}`}>
            <NavLink className={styles.dragHandle} to={"/vessel/" + id}>{name}</NavLink>
            <p>{nameVesselType}</p>
        </div>
    </div>;
};

export default Vessel;
